export const streamController = {
    maxBufferLength: 10,
    maxMaxBufferLength: 10,
    maxBufferSize: 5 * 1000 * 1000,
    liveBackBufferLength: 12,
    liveSyncDurationCount: 6,
    stretchShortVideoTrack: true,
    maxBufferHole: 2.5,
    maxStarvationDelay: 10,
    highBufferWatchdogPeriod: 5,
    maxFragLookUpTolerance: 2.5,
    nudgeOffset: 0.25,
    nudgeMaxRetry: 5
};
